import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { MenuItem, CircularProgress } from '@material-ui/core';

import { eventsRef, childrenRef, makePaymentCall } from '../firebase';

import { Redirect } from 'react-router-dom';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const styles = theme => ({
    root: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
    },
    card: {
        width: '20rem',
        height: '70%',
        top: '15%',
        margin: '0 auto',
        position: 'relative',
        textAlign: 'center',
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    thankYouHolder: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

    },
    loaderRoot: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
    },
    loader: {
        width: '5rem',
        height: '40%',
        top: '30%',
        margin: '0 auto',
        position: 'relative',
    },
    
});

class Donate extends Component {
    constructor(props) {
        super(props);
        
        const { id } = props.match.params;

        var tmp = id.split('_');

        console.log(tmp);

        this.state = {
            name: '',
            email: tmp[1],
            amount: '0',
            eventId: tmp[0],
            thankYou: false,
            processing: false,
            failed: false,
            loading: true,
            kidNames: [],
            kids: [''],
            kid: '',
        };

        this.handler = window.StripeCheckout.configure({
            email: this.state.email,
            key: 'pk_test_3N69atHqqHoVeA0Emsga7FMq',
            image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
            locale: 'auto',
            token: (token) => {
                this.setState({ processing: true });

                makePaymentCall({
                    name: this.state.name,
                    email: this.state.email,
                    amount: this.state.amount * 100,
                    stripeToken: token,
                    eventId: this.state.eventId,
                    refId: this.state.refId,
                    childId: this.state.kid,
                })
                    .then((res) => {
                        toast.success('Payment sucessfull! You will be taken to main screen', {
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        this.setState({
                            redirect: true,
                        })
                    })
                    .catch((errPayentCall) => {
                        console.log(errPayentCall)
                        toast.error('Payment unsucessfull! You will be taken to main screen', {
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        this.setState({
                            processing: false,
                        })
                    });

                /* paymentsRef.add({ 
                    name: this.state.name, 
                    email: this.state.email,
                    amount: this.state.amount * 100,
                    stripeToken: token,
                    eventId: this.state.eventId,
                    status: '0',
                    refId: this.state.refId,
                    childId: this.state.kid,
                })
                .then((docRef) => {
                    toast.warn('Payment submitted! Please wait while we confirm!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    var ref = docRef.onSnapshot( (snapshot) => {
                        if(snapshot.data()['status'] === '1') {
                            toast.success('Payment success!', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });   

                            ref();
                            
                            this.setState({ processing: false });
                            this.setState({ thankYou: true });
                        } else if (snapshot.data()['status'] === '2') {
                            toast.error('Error occurred! Payment not complete', {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                            ref();
                            this.setState({ processing: false });
                            this.setState({ failed: true });
                        }
                    })
                }); */
            }
        });

        console.log(this.state.eventId);

        eventsRef.doc(this.state.eventId).get()
        .then((snapshot) => {
            var {
                refId,
                kids,
                contacts,
            } = snapshot.data();

            var flag = false
            contacts.forEach(contact => {
                if(contact === this.state.email) {
                    flag = true
                    return
                }
            })

            
            if(!flag) {
                toast.warn('You are not invited by the owner!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.setState({
                    redirect: true
                })
            } else {
                this.setState({ 
                    refId,
                    kids
                });
    
                kids.forEach(kid => {
                    childrenRef.doc(kid).get()
                    .then((snapshot) => {
                        const { kidNames } = this.state;
                        kidNames.push(snapshot.data()['firstName'] + ' ' + snapshot.data()['lastName']);
                        this.setState({kidNames});
                    });
                });
            }
        });
    }
    
    donate = () => {
        const { name, email, amount } = this.state;
        let parseAmount = parseFloat(amount) * 100
        if(name === '' || email === '' || amount === '0' || amount === '') {
            toast.warn('Please fill out all fields!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else if (parseAmount < 50 || parseAmount > 99999999) {
            toast.error('Minimum amount is $0.50 & maximum amount is $999,999.99!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            this.handler.open({
                name: 'KBAAZ',
                excerpt: 'Deposit Funds to Account',
                amount: parseAmount,
            });
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    render() {
        const { classes } = this.props;

        if(this.state.redirect) {
            return(
                <Redirect to='/invites' />
            )
        }

        if (this.state.loading && this.state.kids.length !== this.state.kidNames.length) {
            return(<h2>Loading...</h2>);
        }

        if(this.state.processing) {
            return(
                <div className={classes.loaderRoot}>
                    <div className={classes.loader}>
                        <CircularProgress />
                    </div>
                </div>
            );
        }

        if(this.state.thankYou) {
            return(
                <div className={classes.thankYouHolder}>
                    <h1>THANK YOU!!!</h1>
                    <h4>You can close this tab now</h4>
                </div>
            );
        }

        if (this.state.failed) {
            return (
                <div className={classes.thankYouHolder}>
                    <h1>Transaction failed!!!</h1>
                    <h4>You could try again</h4>
                </div>
            );
        }

        return (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <div className={classes.main}>
                        <Typography style={{ paddingBottom: '10px' }} gutterBottom={false} color="primary" variant="title">DONATE FOR EVENT</Typography>
                        <TextField
                            onChange={this.handleChange('name')}
                            style={{ paddingBottom: '10px', width: '80%' }}
                            label="Name"
                        />
                        <TextField
                            disabled
                            value={this.state.email}
                            onChange={this.handleChange('email')}
                            style={{ paddingBottom: '10px', width: '80%' }}
                            label="Email"
                        />
                        <TextField
                            id="select-currency"
                            select
                            style={{ paddingBottom: '10px', width: '80%' }}
                            label="Select kid"
                            value={this.state.kid}
                            onChange={this.handleChange('kid')}
                            SelectProps={{
                                MenuProps: {
                                    className: classes.menu,
                                },
                            }}
                            helperText="Please select child you wish to donate"
                            margin="normal"
                        >
                            {this.state.kidNames.map((option, index) => (
                                <MenuItem key={this.state.kids[index]} value={this.state.kids[index]}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            onChange={this.handleChange('amount')}
                            style={{ paddingBottom: '30px', width: '80%' }}
                            type="number"
                            label="Amount"
                        />
                        <br />
                        <Button onClick={this.donate} color="primary" variant="raised">
                            Donate
                        </Button>
                    </div>
                </Card>
            </div>
        );
    }
}

Donate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Donate);



// WEBPACK FOOTER //
// ./src/components/Donate.js